export default __webpack_public_path__ + "static/media/caferogluyedi1.e9693650.jpg";